import { create } from 'zustand';

/* ==========================================================================
   Recusa do servidor em tempo de execução

   A flag `panel.printing` diz se a loja está no piloto. Mas ela pode ser
   desligada no backoffice com o painel aberto, e aí toda rota da impressão
   passa a responder 404 `printing.disabled`. Quando isso chega, a aba, a faixa
   e o bloco do pedido somem sem esperar a próxima leitura de flags.

   O estado guarda de qual estabelecimento veio a recusa: trocar de loja volta
   a mostrar a impressão sem nenhum efeito de limpeza, porque quem pergunta
   compara com o tenant corrente. Mesmo molde da Vapt IA.
   ========================================================================== */

interface PrintingAvailabilityState {
  disabledTenantId: string | null;
  markDisabled: (tenantId: string) => void;
  clear: () => void;
}

export const usePrintingAvailabilityStore = create<PrintingAvailabilityState>((set) => ({
  disabledTenantId: null,
  markDisabled: (tenantId) => set({ disabledTenantId: tenantId }),
  clear: () => set({ disabledTenantId: null }),
}));

/** A API recusou por loja fora do piloto. */
export function markPrintingDisabled(tenantId: string): void {
  if (tenantId) usePrintingAvailabilityStore.getState().markDisabled(tenantId);
}
